'use client'

import { useSearchParams } from 'next/navigation'
import { useState } from 'react'

import { TFAQCategory } from '@/entities/support'
import { useRouter } from '@/shared/i18n'

const ALL_CATEGORY_CODE = 'ALL'

export const useFAQCategory = (
  categories: TFAQCategory[],
  { replace = false }: { replace?: boolean } = {},
) => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const [category, setCategory] = useState<string>(
    searchParams?.get('category') || ALL_CATEGORY_CODE,
  )

  const handleCategoryChange = (categoryCode: string) => {
    if (categoryCode === category) return

    setCategory(categoryCode)

    const params = new URLSearchParams(searchParams?.toString() ?? '')

    params.delete('page')

    if (categoryCode === ALL_CATEGORY_CODE) {
      params.delete('category')
    } else {
      params.set('category', categoryCode)
    }

    if (replace) {
      router.replace(`?${params.toString()}`)
    } else {
      router.push(`?${params.toString()}`)
    }
  }

  const categoriesWithAll = [
    { categoryCode: ALL_CATEGORY_CODE, categoryName: '전체' },
    ...categories,
  ]

  return { category, categoriesWithAll, handleCategoryChange }
}
